import cn from 'classnames';

import OPE from 'js/on-page-editing';
import { getEnumStringValue, LinkWithText_ThemeMap } from 'js/utils/enum-string-maps';

import Link from 'components/link/Link';

import { ILinkWithText } from 'source/NFR.types';

const LinkWithText: React.FC<ILinkWithText> = ({ link, onPageEditing, text, theme }) => (
  <div className={cn('link-with-text', getEnumStringValue(LinkWithText_ThemeMap, theme))}>
    <h3 {...OPE(onPageEditing?.link)}>
      <Link theme={['actionLink', 'large', 'wrappedHeadingForPrint']} {...link} />
    </h3>
    <p className="link-with-text--text" {...OPE(onPageEditing?.text)}>
      {text}
    </p>
  </div>
);

LinkWithText.displayName = 'LinkWithText';

export default LinkWithText;
